import {
  Component,
  ChangeDetectionStrategy,
  WritableSignal,
  inject,
  input,
} from '@angular/core';
import { KeeniconComponent } from '../../../keenicon/keenicon.component';
import { LayoutService } from '../../../../services/layout.service';

@Component({
  selector: 'ui-sidebar-logo',
  imports: [KeeniconComponent],
  templateUrl: './sidebar-logo.component.html',
  styleUrl: './sidebar-logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarLogoComponent {
  private layoutService = inject(LayoutService);
  logoUrl = input<string>();
  logoMinUrl = input<string>();

  sidebarMinimizedState: WritableSignal<boolean> =
    this.layoutService.sidebarMinimizedState;

  onSidebarToggleClick() {
    this.layoutService.toggleSidebarMinimize();
  }
}
